var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<h4>Tracking ID: {{$ctrl.trackingNumber}}</h4><br/><div class=\"row\" ng-repeat=\"history in $ctrl.tracking.trackingHistory\"><div class=\"col-md-3\"><bold>{{history.trackingStatusDate|date:'MM/dd/yyyy h:mma'}}</bold></div><div class=\"col-md-9\">{{history.trackingStatusDetail}}<br/><i>{{history.trackingLocation}}</i></div></div>";
var id1="tracking-info.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;